import Typography from '@navi/web-ui/lib/primitives/Typography/Typography';
import styles from './index.module.scss';
import {
  Directions,
  Tooltip as TooltipV2,
  TooltipContent,
  TooltipTrigger
} from '../TooltipV2/TooltipV2';
import { FilterItemProps } from './types';
import { CancelIcon } from '@navi/web-ui/lib/icons';

const FilterItem = ({ filter, onRemove }: FilterItemProps) => {
  return (
    <TooltipV2 placement={Directions.BOTTOM} key={filter.filterKey}>
      <TooltipTrigger className={styles.cashCollectedTooltipTriggerWrapper}>
        <div className={styles.filterButton}>
          <Typography variant="h4" color="var(--blue-base)">
            {filter.label}
          </Typography>
          <Typography variant="h4" color="var(--blue-base)" className="ml-1">
            ({filter.count})
          </Typography>
          <CancelIcon onClick={() => onRemove(filter.filterKey)} />
        </div>
      </TooltipTrigger>
      <TooltipContent className="tooltipWrapper whitespace-pre-line">
        {filter.tooltipLabel}
      </TooltipContent>
    </TooltipV2>
  );
};

export default FilterItem;
